export const GET_SF_FILTERS = "GET_SF_FILTERS"
export const GET_SF_FILTERS_SUCCESS = "GET_SF_FILTERS_SUCCESS"
export const GET_SF_FILTERS_ERROR = "GET_SF_FILTERS_ERROR"

export const GET_SOURCE_TYPES = "GET_SOURCE_TYPES"
export const GET_SOURCE_TYPES_SUCCESS = "GET_SOURCE_TYPES_SUCCESS"
export const GET_SOURCE_TYPES_ERROR = "GET_SOURCE_TYPES_ERROR"

export const GET_SF_SMART_VIEWS = "GET_SF_SMART_VIEWS"
export const GET_SF_SMART_VIEWS_SUCCESS = "GET_SF_SMART_VIEWS_SUCCESS"
export const GET_SF_SMART_VIEWS_ERROR = "GET_SF_SMART_VIEWS_ERROR"

export const GET_CAMPAIGN_SOURCE_TYPES = "GET_CAMPAIGN_SOURCE_TYPES"
export const GET_CAMPAIGN_SOURCE_TYPES_SUCCESS = "GET_CAMPAIGN_SOURCE_TYPES_SUCCESS"
export const GET_CAMPAIGN_SOURCE_TYPES_ERROR = "GET_CAMPAIGN_SOURCE_TYPES_ERROR"

export const GET_SOURCE_TYPES_BY_ACCOUNT = "GET_SOURCE_TYPES_BY_ACCOUNT"
export const GET_SOURCE_TYPES_BY_ACCOUNT_SUCCESS = "GET_SOURCE_TYPES_BY_ACCOUNT_SUCCESS"
export const GET_SOURCE_TYPES_BY_ACCOUNT_ERROR = "GET_SOURCE_TYPES_BY_ACCOUNT_ERROR"

export const GET_MARKETING_GROUPS = "GET_MARKETING_GROUPS"
export const GET_MARKETING_GROUPS_SUCCESS = "GET_MARKETING_GROUPS_SUCCESS"
export const GET_MARKETING_GROUPS_ERROR = "GET_MARKETING_GROUPS_ERROR"
